import { CardActions, RefreshButton } from "react-admin";

import ExportToPdfButton from "./buttons/ExportToPdfButton";
import React from "react";

const Actions = ({
  bulkActions,
  basePath,
  displayedFilters,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
}) => (
  <CardActions>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button",
      })}
    <ExportToPdfButton filter={filterValues} />
    <RefreshButton />
  </CardActions>
);
export default Actions;
